import axios from 'axios'

export default {
    async refreshAccessToken({ commit }) {
        // var refreshToken = `${state.refresh_token}`
        var refreshToken=localStorage.getItem('refresh_token');
        try {
            const response = await axios.post('/api/v1/refresh_token', {refresh_token: refreshToken});
            commit('setLogin', response.data.data);
        } catch (error) {
            // 处理 token 刷新失败，比如退出登录
            console.error('Token refresh failed:', error.response.data.msg);
            commit('setLogout');
            return Promise.reject(error);
        }
    },
    
    // 刷新用户权限和菜单
    async refreshUserPermissions({ commit }) {
        var accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            return Promise.reject('No access token');
        }
        
        try {
            const response = await axios.get('/api/v1/user/menus', {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            
            if (response.data.code === 200) {
                // 更新 Vuex 中的菜单、角色和权限
                commit('setUserMenus', response.data.data.menus || []);
                commit('setUserRoles', response.data.data.roles || []);
                commit('setUserPermissions', response.data.data.permissions || []);
                
                console.log('用户权限已更新');
                return Promise.resolve();
            } else {
                return Promise.reject(response.data.msg);
            }
        } catch (error) {
            console.error('刷新权限失败:', error);
            return Promise.reject(error);
        }
    }
}
